import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectOption } from 'common/types/select-option';
import _ from 'lodash';

import { RootState } from './root-reducer';

interface NewListingMetaState {
  yearOptions: SelectOption[];
  makeOptions: SelectOption[];
  modelOptions: SelectOption[];
  trimOptions: SelectOption[];
  bodyTypeOptions: SelectOption[];
  conditionTypeOptions: SelectOption[];
  cylinderTypeOptions: SelectOption[];
  doorTypeOptions: SelectOption[];
  drivetrainTypeOptions: SelectOption[];
  fuelTypeOptions: SelectOption[];
  titleStatusOptions: SelectOption[];
  transmissionTypeOptions: SelectOption[];
}

const prefix = 'newListingMeta';

const initialState: NewListingMetaState = {
  yearOptions: [],
  makeOptions: [],
  modelOptions: [],
  trimOptions: [],
  bodyTypeOptions: [],
  conditionTypeOptions: [],
  cylinderTypeOptions: [],
  doorTypeOptions: [],
  drivetrainTypeOptions: [],
  fuelTypeOptions: [],
  titleStatusOptions: [],
  transmissionTypeOptions: [],
};

const newListingMetaSlice = createSlice({
  name: 'newListingMeta',
  initialState,
  reducers: {
    yearOptions(state, action: PayloadAction<SelectOption[]>) {
      state.yearOptions = action.payload;
    },
    makeOptions(state, action: PayloadAction<SelectOption[]>) {
      state.makeOptions = action.payload;
    },
    modelOptions(state, action: PayloadAction<SelectOption[]>) {
      state.modelOptions = action.payload;
    },
    trimOptions(state, action: PayloadAction<SelectOption[]>) {
      state.trimOptions = action.payload;
    },
    bodyTypeOptions(state, action: PayloadAction<SelectOption[]>) {
      state.bodyTypeOptions = action.payload;
    },
    conditionTypeOptions(state, action: PayloadAction<SelectOption[]>) {
      state.conditionTypeOptions = action.payload;
    },
    cylinderTypeOptions(state, action: PayloadAction<SelectOption[]>) {
      state.cylinderTypeOptions = action.payload;
    },
    doorTypeOptions(state, action: PayloadAction<SelectOption[]>) {
      state.doorTypeOptions = action.payload;
    },
    drivetrainTypeOptions(state, action: PayloadAction<SelectOption[]>) {
      state.drivetrainTypeOptions = action.payload;
    },
    fuelTypeOptions(state, action: PayloadAction<SelectOption[]>) {
      state.fuelTypeOptions = action.payload;
    },
    titleStatusOptions(state, action: PayloadAction<SelectOption[]>) {
      state.titleStatusOptions = action.payload;
    },
    transmissionTypeOptions(state, action: PayloadAction<SelectOption[]>) {
      state.transmissionTypeOptions = action.payload;
    },
  },
});

export const newListingMeta = newListingMetaSlice.reducer;
export const newListingMetaActions = {
  ...newListingMetaSlice.actions,
};

const rootState = (state: RootState) => state;
const newListingMetaSliceState = createSelector(rootState, state => state.newListingMeta);
export const newListingMetaSelectors = {
  yearOptions: createSelector(newListingMetaSliceState, state => state.yearOptions),
  makeOptions: createSelector(newListingMetaSliceState, state => state.makeOptions),
  modelOptions: createSelector(newListingMetaSliceState, state => state.modelOptions),
  trimOptions: createSelector(newListingMetaSliceState, state => state.trimOptions),
  bodyTypeOptions: createSelector(newListingMetaSliceState, state => state.bodyTypeOptions),
  conditionTypeOptions: createSelector(newListingMetaSliceState, state => state.conditionTypeOptions),
  cylinderTypeOptions: createSelector(newListingMetaSliceState, state => state.cylinderTypeOptions),
  doorTypeOptions: createSelector(newListingMetaSliceState, state => state.doorTypeOptions),
  drivetrainTypeOptions: createSelector(newListingMetaSliceState, state => state.drivetrainTypeOptions),
  fuelTypeOptions: createSelector(newListingMetaSliceState, state => state.fuelTypeOptions),
  titleStatusOptions: createSelector(newListingMetaSliceState, state => state.titleStatusOptions),
  transmissionTypeOptions: createSelector(newListingMetaSliceState, state => state.transmissionTypeOptions),
};
